import { Component, Input, OnInit } from '@angular/core';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import { DoctorProfile } from '@cureskin/api-client-rn';

@Component({
  selector: 'doctor-profile',
  templateUrl: './doctor-profile.html',
  styleUrls: ['./doctor-profile.scss'],
  standalone: false,
})
export class DoctorProfileComponent implements OnInit {
  @Input() doctor: DoctorProfile;

  constructor(public readonly userAllocatedDoctorService: UserAllocatedDoctorService) {}

  ngOnInit(): void {
    this.updateDoctor();
  }

  async updateDoctor(): Promise<void> {
    if (this.doctor) {
      return;
    }
    this.doctor = await this.userAllocatedDoctorService.getAllocatedDoctor();
  }
}
